<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            type="text"
            autofocus
            class="form-control"
            v-model="search"
            @input="(val) => searchChange(val)"
            :placeholder="$t(`site.search`)"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          responsive
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
          
        >
          <template #cell(checkbox)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(reference_no)="data">
            <router-link
              :to="{ name: 'ApplicationUser', params: { id: data.item.id } }"
            >
              {{ data.item.reference_no }}</router-link
            >
          </template>
          <template #cell(add_file)="data">
            <b-button
              variant="outline-success"
              class="mr-1"
              :to="{ name: 'ApplicationUser', params: { id: data.item.id } }"
            >
              {{ $t("addwizard.add_file") }}
            </b-button>
          </template>

          <template #cell(status)="data">
            <b-button
              variant="outline-info"
              class="mr-1"
              v-if="data.item.status"
            >
              {{ data.item.status }}
            </b-button>
            
          </template>
          <template #cell(created_at)="data">
            {{ new Date(data.item.created_at).toLocaleString() }}
          </template>
          <template #cell(edit)="data">
            <button
              class="btn btn-icon btn-warning btn-sm"
              @click="editItem(data)"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button
              class="btn btn-icon btn-danger btn-sm"
              @click="deleteItem(data)"
              v-if="$role == 'super_admin'"
            >
              <i class="fa fa-trash"></i>
            </button>
          </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
        <hr />
        <b-pagination
          size="sm"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import UsersController from "@/Controllers/UsersController";
import Auth from "@/Apis/Auth";
import EduProgramsController from "@/Controllers/EduProgramsController";
export default {
  name: "DepartmentsDataTable",
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "reference_no",
            label: this.$i18n.t("addwizard.reference_no"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "status",
            label: this.$i18n.t("addwizard.request_status"),
            sortable: false,
          },
          {
            key: "add_file",
            label: this.$i18n.t("addwizard.add_file"),
            sortable: false,
          },

          {
            key: "created_at",
            label: this.$i18n.t("site.created_at"),
            sortable: true,
            sortDirection: "desc",
          },
        ],
      },
      data: {},
      selectAll: false,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      loading: [],
    };
  },
   created() {
  
   
  },
  methods: {
    async getStatus(item) {
      if (this.loading.includes(item.id)) {
        return;
      }

      const status = await new UsersController().admissionstatus({
        referenceNo: item.reference_no,
      });
      item.status = status.statusNameAr;
      if (status.statusCode == "EN" && Auth.USER.account_type == "student") {
        const info = await new UsersController().enrollmentInfo({
          referenceNo: item.reference_no,
          // referenceNo: "ADM22CG602",
        });
        if (info.matricNo) {
          info.reference_no= item.reference_no;
          const subscribe = await new EduProgramsController().SubscribebyCode(
            info
          );
          if (subscribe.eduProgram) {
            localStorage.setItem("eduProgram", subscribe.eduProgram.id);
            this.$router.push("/");
          }
        }
      }
      this.loading.push(item.id);
      // return s;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new UsersController().getOnlineApplication(
        this.apiParamsConverter()
      );
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      if (Auth.USER.account_type == "student")
        apiParams.filter = "user_id|" + Auth.USER.id;
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>

